import strings from 'utils/strings'
import {
  CONDITION_NAMES,
  QUERY_INPUT_TYPES,
  ACTIVE_HIGH,
  ACTIVE_LOW,
} from 'utils/constants'
import { mapFrom } from 'utils/functional'

const {
  NATIVE_INPUT,
  ANALOG_INPUT,
  DIGITAL_INPUT,
  SWITCH_INPUT,
} = QUERY_INPUT_TYPES

const conditionName = mapFrom({
  0: strings.query_1_label,
  1: strings.query_2_label,
  2: strings.query_3_label,
  3: strings.query_4_label,
  [CONDITION_NAMES.RUNG_ENABLE]: strings.activate_label,
  [CONDITION_NAMES.RUNG_RESET]: strings.reset_label,
})

export const conditionPolarityLabels = {
  [ACTIVE_HIGH]: strings.active_high,
  [ACTIVE_LOW]: strings.active_low,
}

export const conditionLabel = (parentDescription, conditionType) =>
  `${parentDescription}: ${conditionName(conditionType)}`

export const singleConditionStrings = (subType) =>
  ({
    [NATIVE_INPUT]: strings.native_input,
    [ANALOG_INPUT]: strings.analog_input_pin,
    [DIGITAL_INPUT]: strings.digital_input_pin,
    [SWITCH_INPUT]: strings.switch_input,
  }[subType])
